import { PropsWithChildren, ReactNode, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { backButton } from '../helpers/backButton';

export function Page({ children, backClick, insetEnabled = true, edgeToEdge = false, back = true, footer }: PropsWithChildren<{
  insetEnabled?: boolean,
  edgeToEdge?: boolean,
  back?: boolean,
  backClick?: () => void;
  footer?: ReactNode;
}>) {
  const navigate = useNavigate();
  
  useEffect(() => {
    if (back) {
      backButton.show();
      return () => {
        backButton.hide();
      };
    }
    backButton.hide();
    return undefined;
  }, [back]);

  useEffect(() => {
    if (!back) {
      return undefined;
    }
    const off = backButton.onClick(backClick ?? (() => navigate(-1)));
    return () => {
      off();
    };
  }, [back, backClick, navigate]);

  const marginTop = edgeToEdge
    ? '0'
    : insetEnabled
      ? 'calc(var(--tg-viewport-content-safe-area-inset-top) + var(--tg-viewport-safe-area-inset-top))'
      : 'var(--tg-viewport-safe-area-inset-top)';
  const height = edgeToEdge
    ? '100%'
    : insetEnabled
      ? 'calc(100% - var(--tg-viewport-content-safe-area-inset-top) - var(--tg-viewport-safe-area-inset-top))'
      : 'calc(100% - var(--tg-viewport-safe-area-inset-top))';
  return <div style={{
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    height,
    minHeight: 0,
    overflow: 'hidden',
    marginTop
  }}>
    {children}
    {footer && (
      <div style={{
        position: 'absolute',
        left: 0,
        right: 0,
        bottom: 0,
        pointerEvents: 'none',
      }}>
        {footer}
      </div>
    )}
  </div>;
}
